import React from "react";
import { defineMessages, injectIntl, FormattedMessage } from "react-intl";
import config from "config/website";
import FormItem from "theme/components/molecules/Form/Item";
import Select from "theme/components/atoms/Form/Input/Select";
import Swatches from "./Swatches";
import Icon from "theme/components/atoms/Icon";

const messages = defineMessages({
  placeholder: {
    id: "components.organisms.Configurator.OptionPicker.placeholder",
    defaultMessage: "Select your size",
  },
  outofstock: {
    id: "components.organisms.Configurator.OptionPicker.Select.Outofstock",
    defaultMessage: "Product out of stock",
  },
});

const OptionPicker = ({
  intl,
  option,
  selectedOption,
  product,
  disabledOutOfStockOptions,
}) => {
  let label = (
    <FormattedMessage
      id="components.organisms.Configurator.OptionPicker.size"
      defaultMessage="Size"
    />
  );
  if (
    option.id === config.color_attribute_id &&
    option.values.every((value) => value.swatch)
  ) {
    label = (
      <FormattedMessage
        id="components.organisms.Configurator.OptionPicker.chooseColor"
        defaultMessage="Choose a color"
      />
    );

    return (
      <Swatches
        id={option.id}
        name={option.id}
        options={option.values}
        value={selectedOption}
        label={label}
      />
    );
  }

  const renderOptions = (options) =>
    options.map((option) => {
      if (option.disabled === true && !option.availableProducts) {
        return Object.assign({}, option, {
          className: "select__option",
          label: option.label + " " + intl.formatMessage(messages.outofstock),
        });
      }
      let key = option.value;
      let label = [];
      let priceAdditional = 0;
      let basePrice = product.price;
      let diff = 0;

      if (option.disabled === true) {
        label[0] = (
          <span
            className="option-label option-label--out-stock"
            key={"stocklabel" + key}
          >
            {option.label}
          </span>
        );
        label[2] = (
          <span className="out-of-stock" key={"outstock" + key}>
            {intl.formatMessage(messages.outofstock)}
          </span>
        );
        if (!disabledOutOfStockOptions) {
          label[3] = (
            <Icon icon="enveloppe" title="alert return stock" size="mini" />
          );
        }
      } else {
        label[0] = (
          <span className="option-label" key={"label" + key}>
            {option.label}
          </span>
        );
      }
      if (
        option.availableProducts[0] &&
        option.availableProducts[0].finalPrice
      ) {
        priceAdditional =
          option.availableProducts[0].finalPrice.priceInclTax.value.amount;
        diff = priceAdditional - basePrice;

        let decimalPlaces = (diff.toString().split(".")[1] || "").length;

        if (decimalPlaces > 2) {
          diff = Number(diff.toFixed(2));
        }

        if (diff > 0) {
          label[1] = (
            <span className="diff-price" key={"diffpos" + key}>
              +{diff}€
            </span>
          );
        } else if (diff < 0) {
          label[1] = (
            <span className="diff-price" key={"diffneg" + key}>
              -{Math.abs(diff)}€
            </span>
          );
        }
      }

      return Object.assign({}, option, {
        className: "select__option",
        label: label,
        disabled: disabledOutOfStockOptions && option.disabled ? true : false,
      });
    });

  return (
    <div className="configurator__select">
      <FormItem label={""}>
        <Select
          id={option.id}
          name={option.id}
          value={selectedOption}
          options={option.values}
          renderOptions={renderOptions}
          intl={intl}
          product={product}
          placeholder={intl.formatMessage(messages.placeholder)}
          light
        />
      </FormItem>
    </div>
  );
};

OptionPicker.propTypes = {};

export default injectIntl(OptionPicker);
